(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-order-page-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const initCustomOrderForms = (root = document) => {
      root.querySelectorAll('[data-custom-order-form]').forEach((form) => {
        if (form.dataset.customOrderReady == 'true') return;

        const status = form.querySelector('[data-custom-order-status]');
        const submit = form.querySelector('[type="submit"]');

        form.dataset.customOrderReady = 'true';

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          if (!form.reportValidity()) return;

          const variantInput = form.querySelector('[name="id"]');
          if (form.dataset.zeroPriceProductReady != 'true') {
            if (status) status.textContent = 'Select a zero-price custom order product before submitting.';
            return;
          }

          if (!variantInput || !variantInput.value) {
            if (status) status.textContent = 'Select a zero-price custom order product before submitting.';
            return;
          }

          if (submit) submit.disabled = true;
          if (status) status.textContent = 'Adding your request to cart...';

          const submitFormNormally = () => {
            HTMLFormElement.prototype.submit.call(form);
          };

          try {
            if (window.location.hostname == '127.0.0.1' || window.location.hostname == 'localhost') {
              submitFormNormally();
              return;
            }

            const response = await fetch(`${form.action}.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form),
            });

            if (!response.ok) {
              throw new Error('Cart add request failed.');
            }

            if (status) status.textContent = form.dataset.successMessage;
            window.location.href = form.dataset.cartUrl || '/cart';
          } catch (error) {
            submitFormNormally();
          }
        });
      });
    };

    const initCustomOrderSlider = (section) => {
      if (!section || section.dataset.relatedSliderReady == 'true') return;

      const relatedTrack = section.querySelector('[data-related-track]');
      const relatedCards = section.querySelectorAll('[data-related-card]');
      const relatedPrev = section.querySelector('[data-related-prev]');
      const relatedNext = section.querySelector('[data-related-next]');

      if (!relatedTrack || !relatedCards.length || !relatedPrev || !relatedNext) return;

      section.dataset.relatedSliderReady = 'true';

      let relatedIndex = 0;

      const getCardsPerView = () => {
        if (window.innerWidth <= 640) return 1;
        if (window.innerWidth <= 989) return 2;
        if (relatedCards.length <= 3) return Math.max(1, relatedCards.length);
        return 3;
      };

      const syncRelatedSlider = () => {
        const cardsPerView = getCardsPerView();
        relatedTrack.style.setProperty('--related-cards-per-view', cardsPerView);

        const maxIndex = Math.max(0, relatedCards.length - cardsPerView);
        relatedIndex = Math.min(relatedIndex, maxIndex);

        const firstCard = relatedCards[0];
        const cardWidth = firstCard.getBoundingClientRect().width;
        const trackStyle = window.getComputedStyle(relatedTrack);
        const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || 0);
        const offset = relatedIndex * (cardWidth + gap);

        relatedTrack.style.transform = `translateX(-${offset}px)`;

        const atStart = relatedIndex <= 0;
        const atEnd = relatedIndex >= maxIndex;

        relatedPrev.disabled = atStart;
        relatedPrev.classList.toggle('is-disabled', atStart);
        relatedNext.disabled = atEnd;
        relatedNext.classList.toggle('is-disabled', atEnd);
      };

      relatedPrev.addEventListener('click', () => {
        relatedIndex = Math.max(0, relatedIndex - 1);
        syncRelatedSlider();
      });

      relatedNext.addEventListener('click', () => {
        const maxIndex = Math.max(0, relatedCards.length - getCardsPerView());
        relatedIndex = Math.min(maxIndex, relatedIndex + 1);
        syncRelatedSlider();
      });

      window.addEventListener('resize', syncRelatedSlider);
      syncRelatedSlider();
    };

    const initAllCustomOrderSliders = (root = document) => {
      initCustomOrderForms(root);
      root.querySelectorAll('[data-custom-order-section]').forEach(initCustomOrderSlider);
    };

    if (document.readyState == 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllCustomOrderSliders(), { once: true });
    } else {
      initAllCustomOrderSliders();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllCustomOrderSliders(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
